import {Todo} from "@models/todo.model.ts";

export class TodoSection {
  id: number;
  name : string;
  sequence : number;
  todos: Todo[];

  constructor() {

    this.id = -1;
    this.name = "";
    this.sequence = 0;
    this.todos = []
  }
}
